<!--
 * @Date: 2020-03-12 19:15:45
 * @LastEditTime: 2020-03-15 16:44:02
 * @title: file content
-->
<template>
  <div class="uploader">
    <div class="uploader-wraper">
      <v-list v-if="!manageFiles.length" dense>
        <v-list-item v-for="(item, index) in fileList" :key="item.name+index">
          <div class="horizontal-wrap">
            <img class="gutter" :src="item.icon" alt />
            <div
              style="width:280px;display: inline-block;"
              class="text-truncate gutter"
              :title="item.name"
            >{{item.name}}</div>
            <el-input
              style="background-color:#424242;width:150px;"
              size="small"
              v-model="item.title"
              placeholder="請輸入描述內容"
              class="gutter"
            ></el-input>
            <span class="status gutter">{{item.status}}</span>
            <el-progress
              class="status"
              style="width:150px;display:inline-block;"
              :stroke-width="12"
              :percentage="item.progress"
            ></el-progress>
            <div>
              <i
                @click="delUploas(item.uid,index)"
                class="el-icon-switch-button gutter icon"
                title="取消上傳"
              ></i>
              <i @click="delUploas(item.uid,index)" class="el-icon-delete gutter icon" title="刪除文件"></i>
            </div>
          </div>
        </v-list-item>
        <el-upload
          :action="uploadUrl"
          :on-change="change"
          multiple
          ref="upload"
          :show-file-list="false"
          :auto-upload="false"
          :before-upload="beforeUpload"
          :http-request="uploadFile"
          :on-success="handleSuccess"
        >
          <i slot="trigger" class="el-icon-plus gutter icon"></i>
          <span class="gutter">選擇文件（圖片|音檔）</span>
          <v-btn @click.stop="submitUpload">提交</v-btn>
          <v-btn @click.stop="clear" color="error" style="margin-left: 10px;">清空</v-btn>
        </el-upload>
      </v-list>
      <div v-else>
        <el-table
          ref="multipleTable"
          :data="manageFiles"
          tooltip-effect="dark"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" min-width="55"></el-table-column>
          <el-table-column label="日期" width="120">
            <template slot-scope="scope">{{ formatDate(scope.row.ctime) }}</template>
          </el-table-column>
          <el-table-column label="文件名" min-width="100">
            <template slot-scope="scope">
              <span
                style="font-size:13px;"
                class="text-truncate gutter"
                :title="scope.row.originalname"
              >{{scope.row.url}}</span>
            </template>
          </el-table-column>
          <el-table-column label="描述" min-width="100">
            <template slot-scope="scope">
              <el-input
                style="background-color:#424242;color:#fff;"
                size="small"
                v-model="scope.row.title"
                placeholder="請輸入描述內容"
                class="gutter"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i
                @click.stop="deleteManageFile([{id:scope.row.id}])"
                class="el-icon-delete gutter icon"
                title="刪除文件"
              ></i>
              <v-btn
                @click.stop="updateManageFile([{id:scope.row.id,title:scope.row.title}])"
                small
                color="error"
                style="margin-left:10px;"
              >送出修改</v-btn>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:10px;">
          <v-btn @click.stop="batchUpdateManageFiles" small style="margin-left:10px;">批量修改</v-btn>
          <v-btn
            @click.stop="batchDelManageFiles"
            small
            color="error"
            style="margin-left:10px;"
          >批量刪除</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { formatDate } from '@/lib/util'
import { uploadFileRequest, batchUpdateDesc, batchDelUploadFile } from '@/lib/media/upload-file'
export default {
  props: {
    manageFiles: {
      type: Array,
      default: () => {
        return []
      }
    },
    uploadForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  name: 'MUploader',
  data() {
    return {
      multipleSelection: [],
      form: {
        name: '',
        title: '',
        icon: '',
        status: '',
        progress: '',
        extension: '',
        size: '',
        uid: '',
        reload: false,
        finished: false
      },
      uploadFileList: [],
      loading: false,
      imageLimit: 2, // 图片最大2mb
      videoLimit: 50, // 视频最大50mb
      fileList: [],
      videoType: [ 'video/mp4', 'video/ogg', 'video/wav', 'audio/wav', 'audio/mp3' ], // 视频允许类型
      imageType: [ 'image/gif', 'image/jpg', 'image/jpeg', 'image/png' ], // 图片允许类型
      uploadUrl: '/upload',
      pictureIcon: require('@/assets/images/picture.png'),
      videoIcon: require('@/assets/images/video.png'),
      otherIcon: require('@/assets/images/other.png')
    }
  },

  methods: {
    formatDate,
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    /* ---------------------------------- 批量更新描述 ---------------------------------- */

    batchUpdateManageFiles() {
      const list = []
      this.manageFiles.forEach((item, index) => {
        const filter = this.multipleSelection.filter(f => f.id === item.id)[ 0 ]
        if (filter) {
          list.push({
            id: item.id,
            title: item.title
          })
        }
      })
      this.updateManageFile(list)
    },

    /* ------------------------------ 更新一个或多个描述 ------------------------------ */

    updateManageFile(list) {
      batchUpdateDesc(list)
        .then(() => {
          this.$message.success('修改成功!')
          this.loadManageFiles()
        }).catch(err => {
          console.log(err)
        })
    },

    /* ---------------------------------- 批量刪除图片视频 ---------------------------------- */

    batchDelManageFiles() {
      const list = []
      this.manageFiles.forEach((item, index) => {
        const filter = this.multipleSelection.filter(f => f.id === item.id)[ 0 ]
        console.log(filter)
        if (filter) {
          list.push({
            id: item.id
          })
        }
      })
      this.deleteManageFile(list)
    },

    /* ------------------------------- 拉取当前模态框已上传的数据 ------------------------------- */

    loadManageFiles() {
      this.$emit('loadManageFiles')
    },

    /* --------------------------------- 刪除一个或多个图片数据 --------------------------------- */

    deleteManageFile(list) {
      this.$confirm('此操作將永久刪除資料, 是否繼續?', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        batchDelUploadFile(list)
          .then(() => {
            this.$message.success('刪除成功!')
            this.loadManageFiles()
          }).catch(err => {
            console.log(err)
          })
      }).catch(() => {
        this.$message.info('取消刪除!')
      })
    },

    /* ---------------------------------- 上传部分的 --------------------------------- */

    // 提交上传
    submitUpload() {
      this.$refs.upload.submit()
    },
    // 更新fileList界面值
    updateFileList(uid, attr, value) {
      const file = this.fileList.filter(f => f.uid === uid)[ 0 ]
      file && this.$set(file, attr, value)
    },
    clear() {
      this.fileList = []
    },
    // 上传
    uploadFile(item) {
      let file = item.file
      // fileList只是用于进度条等界面ui使用
      let curItem = this.fileList.filter(f => f.name === file.name)[ 0 ]
      if (!curItem) {
        return false
      }
      let form = new FormData()
      curItem.status = '上傳中...'
      form.append('file', file)
      form.append('title', curItem.title)
      form.append('name', curItem.name)
      form.append('size', curItem.size)
      form.append('extension', curItem.extension)
      form.append('type', curItem.type)
      for (const key in this.uploadForm) {
        if (this.uploadForm.hasOwnProperty(key)) {
          form.append(key, this.uploadForm[ key ])
        }
      }
      let cancelToken = axios.CancelToken
      item.file.source = cancelToken.source()
      curItem.file = file
      // 开始上传
      uploadFileRequest(form, item.file.source, progress => {
        this.updateProgress(item.file, parseInt(progress))
      }).then(res => {
        this.updateFileList(curItem.uid, 'status', '上傳完成')
        this.$refs.upload.clearFiles()
      }).catch(error => {
        this.updateFileList(curItem.uid, 'status', '上傳失敗')
        console.log(error)
      })
    },
    // 更新进度条
    updateProgress(file, progress) {
      this.updateFileList(file.uid, 'progress', progress)
    },
    // 取消/刪除上传
    delUploas(uid, index) {
      let curIndex = -1
      for (curIndex = 0; curIndex < this.fileList.length; curIndex++) {
        if (this.fileList[ curIndex ].uid === uid) {
          break
        }
      }
      let file = this.fileList[ curIndex ].file
      if (file && file.source) {
        file.source.cancel()
      }
      this.fileList.splice(index, 1)
    },
    // 选择文件时候
    change(file, fileList) {
      console.log(file, fileList)
      if (file.status === 'ready') {
        let type = this.getFileType(file.raw)
        const icon = type === 'image'
          ? this.pictureIcon : type === 'video'
            ? this.videoIcon : this.otherIcon
        const extension = file.name.split('.').pop()
        const form = {
          name: file.name,
          title: '',
          type: type,
          icon: icon,
          status: '等待上傳',
          progress: 0,
          extension: extension,
          size: file.size,
          uid: file.uid
        }
        const list = this.fileList.filter(f => f.name === file.name)
        if (form.icon === this.otherIcon) {
          this.$message.error('請選擇正確的文件格式')
          return
        }
        if (list.length) {
          this.$message.error('已經上傳過了')
          return
        }
        this.fileList.push(form)
      }
    },
    getFileType(file) {
      return this.videoType.indexOf(file.type) !== -1
        ? 'video' : this.imageType.indexOf(file.type) !== -1 ? 'image' : ''
    },
    // 上传之前先判断大小和类型
    beforeUpload(file) {
      const size = file.size / 1024 / 1024 < 10
      const isVideo = this.videoType.indexOf(file.type) !== -1
      const isImage = this.imageType.indexOf(file.type) !== -1
      const uploaded = this.fileList.filter(f => f.name === file.name)[ 0 ]
      if (!isVideo && !isImage) {
        this.$message.error('請選擇正確的文件格式')
        return false
      }
      // 图片最大2mb
      if (isVideo && size > this.videoLimit) {
        this.$message.error('上傳音檔大小不能超過50MB哦!')
        return false
      }
      // 视频最大50mb
      if (isImage && size > this.imageLimit) {
        this.$message.error('上傳影像大小不能超過2MB哦!')
        return false
      }
      // 上传过的进度条大于0
      if (uploaded && uploaded.progress > 0) {
        console.log('已經上傳過了')
        return false
      }
    },
    // 上传成功
    handleSuccess(res, file) {
      this.uploadFlag = false
      this.uploadPercent = 0
      if (res.code === 0) {
        this.$message.success('上傳成功')
      } else {
        this.$message.error('音檔上傳失敗，請重新上傳！')
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.uploader-wraper {
  width: 100%;
  min-height: 400px;
  padding: 15px;
  font-size: 12px;
  .horizontal-wrap {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .gutter {
    margin-left: 10px;
  }
  .icon {
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    &:hover {
      color: #5cb6ff;
    }
  }
  .status {
    width: 70px;
  }
}
</style>
<style>
.el-upload-dragger,
.uploader-wraper input,
.el-upload-list--picture-card .el-upload-list__item,
.el-table th,
.el-table tr,
.el-table--enable-row-hover .el-table__body {
  background-color: #424242 !important;
}
.el-upload-dragger .el-upload__text,
.el-upload__tip,
.cell,
.el-progress__text,
.el-checkbox,
.el-input input {
  color: #ccc !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #303030 !important;
}
</style>
